import React, { useContext, useEffect, useState } from 'react'
import { QlikUIContext } from '../QlikUIContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus,
  faFilter,
  faLock,
  faPen
} from '@fortawesome/free-solid-svg-icons'

import {
  IconButton,
  Tooltip,
  Card,
  CardHeader,
  CardMedia,
  CardContent,
  Typography,
  useTheme,
  makeStyles,
  CardActionArea,
  Button
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { stylesMui } from './styles/reportCard.styles'
import { Fragment } from 'react'

export const ReportCard = ({
  ambitReport,
  newCard,
  onNewStreamReport,
  onViewStreamReport,
  onEditStreamReport
}) => {
  const context = useContext(QlikUIContext)
  const [isAdmin, setIsAdmin] = useState(false)

  const [t] = useTranslation(['qlik'])

  const currentTheme = useTheme()
  const useStyles = makeStyles(stylesMui(currentTheme))
  const classes = useStyles()

  useEffect(() => {
    const roles = context.roles.split(',')
    setIsAdmin(roles.includes('Administracion'))
  }, [])

  return (
    <React.Fragment>
      {newCard && (
        <Card className={classes.card}>
          <IconButton
            size='small'
            color='primary'
            disabled={true}
            className={classes.faPlus}
          >
            <FontAwesomeIcon icon={faPlus} fixedWidth />
          </IconButton>
          <Button
            className={classes.btnNew}
            size='small'
            color='primary'
            variant='contained'
            onClick={() => onNewStreamReport(1)}
          >
            {t('qlik:reportCard.buttonNew')}
          </Button>
          <Button
            className={classes.btnNewWithFilters}
            size='small'
            color='primary'
            variant='contained'
            onClick={() => onNewStreamReport(2)}
          >
            {t('qlik:reportCard.buttonNewWithFilters')}
          </Button>
        </Card>
      )}

      {!newCard && (
        <CardActionArea
          className={classes.card}
          onClick={() => {
            onViewStreamReport(ambitReport.Report.Type, ambitReport.Report)
          }}
        >
          <Card className={classes.card}>
            <CardHeader
              action={
                isAdmin && (
                  <Fragment>
                    <Tooltip title={t('qlik:reportCard.buttonEdit')}>
                      <IconButton
                        size='small'
                        color='primary'
                        onClick={() => onEditStreamReport(ambitReport.Report)}
                      >
                        <FontAwesomeIcon icon={faPen} fixedWidth />
                      </IconButton>
                    </Tooltip>
                    {!ambitReport.Report.Public && (
                      <Tooltip title={t('qlik:reportCard.infoNotAdmin')}>
                        <IconButton size='small' color='secondary'>
                          <FontAwesomeIcon icon={faLock} fixedWidth />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Fragment>
                )
              }
              avatar={
                isAdmin && ambitReport.Report.Type === 2 ? (
                  <Tooltip title={t('qlik:reportCard.filterType')}>
                    <IconButton color='secondary' size='small'>
                      <FontAwesomeIcon icon={faFilter} fixedWidth />
                    </IconButton>
                  </Tooltip>
                ) : undefined
              }
            ></CardHeader>
            <CardMedia
              component='img'
              className={classes.cardMedia}
              image={ambitReport.ThumbnailUrl}
            />
            <CardContent className={classes.cardContent}>
              <Typography
                gutterBottom
                variant='h6'
                className={classes.cardContentTitle}
              >
                {ambitReport.Report.Name}
              </Typography>
              <Typography
                variant='caption'
                color='secondary'
                align='center'
                display='block'
              >
                {ambitReport.Description}
              </Typography>
            </CardContent>
          </Card>
        </CardActionArea>
      )}
    </React.Fragment>
  )
}
